import React from 'react'
import {useSelector} from 'react-redux'
import {IdHandoverRecordsState} from 'model/dashboardHandoverRecord/dHandoverRecordReducer'
import {Trans} from '@lingui/macro'
import {Alert} from 'components/UI/Alert/Alert'

import {Button} from 'components/UI/Button/Button'
import { numberCurrencyFormat } from 'constants/convertToLocalCurrency';




// Type
export type typePopupEdit = {
    variant?: string
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const PopupDetails: React.FC<typePopupEdit> = ({ setOpenPopup}) => {



    const dataObject = useSelector((state: {dHRecord:IdHandoverRecordsState}) =>
    state.dHRecord.detailItem)

    const openDate = (dataObject && dataObject.openDate!==null) ? dataObject.openDate.substring(0, 19).replace('T', ' , ') : '-'
    const closeDate = (dataObject && dataObject.closeDate !==null) ? dataObject.closeDate.substring(0, 19).replace('T', ' , ') : '-'


    return(
        <>
            {dataObject
                ?  <>
                    <div className="grid gap-x-8 grid-cols-1 sm:grid-cols-2 border-b sm:border sm:rounded-md sm:px-4">

                        <div className="flex flex-wrap gap-x-4 py-2 sm:py-4 sm:border-t-0 border-b sm:py-4">
                            <div className="text-gray-500 text-left"><Trans>Store:</Trans></div>
                            <div className="text-gray-90 text-left">{dataObject.pos?.store?.name}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-2 sm:py-4 border-t border-b sm:py-4 sm:border-t-0">
                            <div className="text-gray-500 text-left"><Trans>POS number</Trans>:</div>
                            <div className="text-gray-90 text-left">{dataObject.pos?.posNumber}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-2 sm:py-4 sm:border-0">
                            <div className="text-gray-500 text-left"><Trans>Date open:</Trans></div>
                            <div className="text-gray-90 text-left">{openDate}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-2 border-t sm:py-4 sm:border-0">
                            <div className="text-gray-500 text-left"><Trans>Date close:</Trans></div>
                            <div className="text-gray-90 text-left">{closeDate}</div>
                        </div>

                    </div>

                    <div className="mt-6 sm:mt-8 grid gap-x-8 grid-cols-1 sm:grid-cols-2 sm:border sm:rounded-md sm:px-4">

                        <div className="flex flex-wrap gap-x-4 py-2 sm:py-4 border-t border-b  sm:border-t-0">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Count of Sales:</Trans>
                            </div>
                            <div className="text-gray-90 text-left">{dataObject.salesCount ? dataObject.salesCount : '-'}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-2 border-b sm:py-4">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Amount of Sales:</Trans>
                            </div>
                            <div className="text-gray-90 text-left">{dataObject.salesAmount && numberCurrencyFormat(dataObject.salesAmount)}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-2 border-b sm:py-4">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Cash payment:</Trans>
                            </div>
                            <div className="text-gray-90 text-left">{dataObject.salesWithCash && numberCurrencyFormat(dataObject.salesWithCash)}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-2 border-b  sm:py-4">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Card payment:</Trans>
                            </div>
                            <div className="text-gray-90 text-left">{dataObject.salesWithCards && numberCurrencyFormat(dataObject.salesWithCards)}</div>
                        </div>
                        <div className="flex flex-wrap gap-x-4 py-2 border-b sm:border-b-0 sm:py-4">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Cashless payment:</Trans>
                            </div>
                            <div className="text-gray-90 text-left">{dataObject.salesWithCashless &&  numberCurrencyFormat(dataObject.salesWithCashless)}</div>
                        </div>

                    </div>

                    <div className="mt-6 sm:mt-8 grid gap-x-8 grid-cols-1 sm:grid-cols-2 sm:border sm:rounded-md sm:px-4">

                        <div className="flex flex-wrap gap-x-4 py-2 sm:py-4 border-t border-b  sm:border-t-0">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Count of refund:</Trans>
                            </div>
                            <div className="text-gray-90 text-left">{dataObject.refundsCount ? dataObject.refundsCount: '-'}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-2 border-b sm:py-4">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Amount of refund:</Trans>
                            </div>
                            <div className="text-gray-90 text-left">{dataObject.refundsAmount && numberCurrencyFormat(dataObject.refundsAmount)}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-2 border-b  sm:py-4">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Cash refund:</Trans>
                            </div>
                            <div className="text-gray-90 text-left">{dataObject.refundsWithCash && numberCurrencyFormat(dataObject.refundsWithCash)}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-2 border-b  sm:py-4">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Card refund:</Trans>
                            </div>
                            <div className="text-gray-90 text-left">{dataObject.refundsWithCards && numberCurrencyFormat(dataObject.refundsWithCards)}</div>
                        </div>
                        <div className="flex flex-wrap gap-x-4 py-2 border-b sm:border-b-0 sm:py-4">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Cashless refund:</Trans>
                            </div>
                            <div className="text-gray-90 text-left">{dataObject.refundsWithCashless && numberCurrencyFormat(dataObject.refundsWithCashless)}</div>
                        </div>
                    </div>

                    <div className="mt-6 sm:mt-8 grid gap-x-8 grid-cols-1 sm:grid-cols-2 sm:border sm:rounded-md sm:px-4">

                        <div className="flex flex-wrap gap-x-4 py-2 border-b sm:border-b-0 sm:py-4">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Cash desk was handed over by:</Trans>
                            </div>
                            <div className="flex items-center text-gray-90 text-left">{dataObject.userName ?dataObject.userName: '-'}</div>
                        </div>
                        <div className="flex flex-wrap gap-x-4 py-2  sm:py-4">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Cashier name:</Trans>
                            </div>
                            <div className="flex items-center text-gray-90 text-left">{dataObject.cashierName? dataObject.cashierName : '-'}</div>
                        </div>
                    </div>


                    <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                        <Button type="button" secondary={true} label={<Trans>Close</Trans>} onClick={() => setOpenPopup(false)}/>
                    </div>


                </>
                : <Alert type="error" title={<Trans>Have no data.</Trans>}/>
            }
        </>
    )
}
